import { getUser } from '../../main/util/auth';
import { isInApp } from '../../main/util/is-app';
import type { EventHandler } from '../components/eventing-service-provider/eventing-service-provider';
import { EventName } from '../interfaces/events.interface';

export const sportncoEventListener: EventHandler = (event) => {
    if (!isInApp()) {
        return;
    }
    const user = getUser();
    const userId = user?.id_token;
    switch (event.name) {
        case EventName.WINDOW_RESIZE:
            window.SNCAppBridges.notifySizeChanged(event.width, event.height);
            return false;
        case EventName.USER_PROFILE_UPDATE:
        case EventName.USER_DEPOSIT:
        case EventName.USER_WITHDRAWAL:
            window.SNCAppBridges.requestRefreshAccount();
            return false;
        case EventName.LOGIN_REQUEST:
            window.SNCAppBridges.requestLogin();
            return true;
        case EventName.LOGOUT_REQUEST:
            window.SNCAppBridges.requestLogout();
            return true;
        case EventName.NAVIGATE:
            if (/\/sports\//i.test(event.path)) {
                window.postMessage({
                    // add here user credential?
                    message: 'pam_request_close_mobile_app_webview',
                    args: {
                        playerId: userId,
                    },
                });
                return;
            }

            //window.SNCAppBridges.navigateWeb(event.path, true, false);
            return false;
    }
};
